import React from "react"
import { useRouter } from "next/router"

import { useQueryParams } from "@/hooks/useQueryParams"

const APPS = [
  { label: "Main App", value: "/" },
  { label: "Agent Training", value: "/agent-training" },
]

export const AppSwitcher: React.FC = () => {
  const router = useRouter()
  const queryParams = useQueryParams()
  const current =
    APPS.find((app) =>
      app.value === "/"
        ? router.pathname === "/"
        : router.pathname.startsWith(app.value),
    ) || APPS[0]

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const href = queryParams.getHref(e.target.value)
    void router.push(href)
  }

  return (
    <select
      value={current.value}
      onChange={handleChange}
      className="rounded-md border border-surface-1 bg-surface-default px-2 py-1 text-sm text-coval-text"
    >
      {APPS.map((app) => (
        <option key={app.value} value={app.value}>
          {app.label}
        </option>
      ))}
    </select>
  )
}
